export const resolveLocationSearchValue = (selectedLocation, inputValue) => {
  if (selectedLocation?.type === "state") {
    return String(selectedLocation.state || selectedLocation.city || inputValue || "").trim();
  }
  if (selectedLocation?.city) {
    return String(selectedLocation.city).trim();
  }
  return String(inputValue || "").trim();
};
